import React from "react";
import * as AlertDialogPrimitive from "@radix-ui/react-alert-dialog";
import { cn } from "./utils";
import { buttonVariants } from "./button";

export const AlertDialog = AlertDialogPrimitive.Root;

export const AlertDialogContent = React.forwardRef(({ className, ...props }, ref) => (
  <AlertDialogPrimitive.Portal>
    <AlertDialogPrimitive.Overlay className="tw-fixed tw-inset-0 tw-z-[1070] tw-bg-slate-900/40 data-[state=open]:tw-animate-d2c-fade-in" />
    <AlertDialogPrimitive.Content
      ref={ref}
      className={cn(
        "d2c-ui tw-fixed tw-left-1/2 tw-top-1/2 tw-z-[1071] tw-grid tw-w-[calc(100%-2rem)] tw-max-w-lg -tw-translate-x-1/2 -tw-translate-y-1/2 tw-gap-4 tw-rounded-lg tw-border tw-bg-background tw-p-6 tw-font-sans tw-text-sm tw-leading-5 tw-text-foreground tw-shadow-lg data-[state=open]:tw-animate-d2c-pop-in",
        className,
      )}
      {...props}
    />
  </AlertDialogPrimitive.Portal>
));
AlertDialogContent.displayName = "AlertDialogContent";

export const AlertDialogHeader = ({ className, ...props }) => (
  <div className={cn("tw-flex tw-flex-col tw-gap-1.5", className)} {...props} />
);

export const AlertDialogFooter = ({ className, ...props }) => (
  <div className={cn("tw-flex tw-flex-col-reverse tw-gap-2 sm:tw-flex-row sm:tw-justify-end", className)} {...props} />
);

export const AlertDialogTitle = React.forwardRef(({ className, ...props }, ref) => (
  <AlertDialogPrimitive.Title
    ref={ref}
    className={cn("tw-m-0 tw-font-sans tw-text-base tw-font-semibold tw-leading-6 tw-text-foreground", className)}
    {...props}
  />
));
AlertDialogTitle.displayName = "AlertDialogTitle";

export const AlertDialogDescription = React.forwardRef(({ className, ...props }, ref) => (
  <AlertDialogPrimitive.Description ref={ref} className={cn("tw-m-0 tw-text-sm tw-text-muted-foreground", className)} {...props} />
));
AlertDialogDescription.displayName = "AlertDialogDescription";

// Plain buttons rather than Radix Action/Cancel, so the caller decides when the
// dialog closes (it stays open while a request is in flight).
export const AlertDialogCancelButton = ({ className, ...props }) => (
  <button type="button" className={cn(buttonVariants({ variant: "outline" }), className)} {...props} />
);
